import {Button, Card, Col, Form, Pagination, Row} from 'react-bootstrap'
import {IResultsJson} from '../../oneLead/oneleadTypes'
import {useState} from 'react'
import {ModalInfoPlan} from './ModalInfoPlan'
import {useDisclourse} from '../../../hooks/useDisclourse'
import Lottie from 'lottie-react'
import endLottie from '../../../assets/lotties/end-quotes.json'
import {SIZE_PAGE_QUICK_QUOTE} from '../../../helpers/consts'
import {PaginationUtils} from '../../shared/PaginationUtils'
import {IForm} from '../oneQuoteTypes'

interface IResultProps {
  result: IResultsJson
  loadMoreQuotes: (pag: number, order?: string) => void
  orderQuery: string
  currentPage: number
  updatePage: (n: number) => void
  onSelectPlan?: (plan: any) => void
  queryData?: IForm
}

export const ResultsCards = ({
  result,
  orderQuery,
  loadMoreQuotes,
  currentPage,
  updatePage,
  onSelectPlan,
  queryData,
}: IResultProps) => {
  const [infoPlan, setInfoPlan] = useState<null | IResultProps['result']['plans'][0]>(null)
  const {isOpen, onClose, onOpen} = useDisclourse()

  if (result.error) {
    return <div>No found data</div>
  }
  const totalPages = Math.ceil(result.total / SIZE_PAGE_QUICK_QUOTE)

  const {start, end} = PaginationUtils.getPaginationRange(
    currentPage,
    SIZE_PAGE_QUICK_QUOTE,
    result.total
  )

  return (
    <>
      <div className='mt-6'>
        <div className='results-header'>
          <div className='pagination-container'>
            <Pagination size='sm'>
              {/* Botón "Anterior" */}
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => {
                  if (currentPage > 1) {
                    updatePage(currentPage - 1)
                    loadMoreQuotes(currentPage - 1)
                  }
                }}
              />

              {/* Siempre mostrar el número 1 */}
              <Pagination.Item
                active={currentPage === 1}
                onClick={() => {
                  if (currentPage !== 1) {
                    updatePage(1)
                    loadMoreQuotes(1)
                  }
                }}
              >
                1
              </Pagination.Item>

              {/* Mostrar puntos suspensivos si hay páginas superiores a 2 */}
              {currentPage > 3 && <Pagination.Ellipsis disabled />}

              {/* Mostrar el rango de páginas visibles */}
              {PaginationUtils.getVisiblePages(currentPage, totalPages)
                .slice(1)
                .map((page) => (
                  <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => {
                      if (page !== currentPage) {
                        updatePage(page)
                        loadMoreQuotes(page)
                      }
                    }}
                  >
                    {page}
                  </Pagination.Item>
                ))}

              {/* Botón "Siguiente" */}
              <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => {
                  if (currentPage < totalPages) {
                    updatePage(currentPage + 1)
                    loadMoreQuotes(currentPage + 1)
                  }
                }}
              />
            </Pagination>
            <div className='pagination-text'>
              Showing {start} to {end} of {result.total} plans
            </div>
          </div>
          <div className='col-md-3'>
            <div className='results-filter'>
              {/* <Form.Select aria-label='Default select example'>
              <option>Open this select menu</option>
              <option value='1'>One</option>
              <option value='2'>Two</option>
              <option value='3'>Three</option>
            </Form.Select> */}
              <Col lg={12} md={12} sm={12} xs={12}>
                <Form.Group>
                  <Form.Label>Order</Form.Label>
                  <Form.Control
                    as='select'
                    name='order'
                    value={orderQuery}
                    onChange={(e) => {
                      console.log('orderQuery', orderQuery)
                      console.log('e.target.value', e.target.value)
                      if (e.target.value === orderQuery) return
                      e.preventDefault()
                      updatePage(1)
                      loadMoreQuotes(1, e.target.value)
                    }}
                  >
                    <option value='asc'>Ascending</option>
                    <option value='desc'>Descending</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </div>
          </div>
        </div>
        <div className='mt-4 results-cards'>
          {result.plans.map((plan) => (
            <Card className='rounded-1 mb-4' key={plan.id}>
              <Card.Header className='align-items-center'>
                <Card.Title>{plan.issuer.name}</Card.Title>
                <div className='d-flex gap-2'>
                  <Button
                    variant='secondary'
                    size='sm'
                    onClick={() => {
                      onOpen()
                      setInfoPlan(plan)
                    }}
                  >
                    <i className='bi bi-search' />
                    PLAN DETAILS
                  </Button>
                  <Button
                    variant='primary'
                    size='sm'
                    onClick={() => {
                      onSelectPlan?.(plan)
                    }}
                  >
                    <i className='bi bi-check-circle' />
                    SELECT PLAN
                  </Button>
                </div>
              </Card.Header>
              <Card.Body>
                <h4 className='text-info fs-3'>{plan.name}</h4>
                <div
                  className='d-flex align-items-center mb-1 flex-wrap'
                  style={{fontSize: '11px'}}
                >
                  <span>{plan.metal_level}</span>
                  <span>
                    <i className='bi bi-dot fs-1' />
                  </span>
                  <span>{plan.type}</span>
                  <span>
                    <i className='bi bi-dot fs-1' />
                  </span>
                  <span>
                    <span className='fw-bold'>Plan ID:</span> {plan.id}
                  </span>
                  <span>
                    <i className='bi bi-dot fs-1' />
                  </span>
                  <span>
                    <span className='fw-bold'>Rating:</span>{' '}
                    {plan.quality_rating.global_rating > 0 &&
                      [1, 2, 3, 4, 5].map((n) => (
                        <i
                          className='bi bi-star-fill'
                          key={n}
                          style={{
                            color: n <= plan.quality_rating.global_rating ? '#da9400' : '#565454',
                          }}
                        />
                      ))}
                    {plan.quality_rating.global_rating === 0 && (
                      <span> {plan.quality_rating.global_not_rated_reason}</span>
                    )}
                  </span>
                  <span>
                    <i className='bi bi-dot fs-1' />
                  </span>
                  <span className='d-flex align-items-center'>
                    <span className='fw-bold'>Dental adults:</span>{' '}
                    {plan.benefits.find((p) => p.type === 'BASIC_DENTAL_CARE_ADULT')?.covered ? (
                      <i className='bi bi-check fs-2' style={{color: 'green'}} />
                    ) : (
                      <i className='bi bi-x fs-2' style={{color: 'red'}} />
                    )}
                  </span>
                  <span>
                    <i className='bi bi-dot fs-1' />
                  </span>
                  <span className='d-flex align-items-center'>
                    <span className='fw-bold'>Dental children:</span>{' '}
                    {plan.benefits.find((p) => p.type === 'DENTAL_CHECK_UP_FOR_CHILDREN')
                      ?.covered ? (
                      <i className='bi bi-check fs-2' style={{color: 'green'}} />
                    ) : (
                      <i className='bi bi-x fs-2' style={{color: 'red'}} />
                    )}
                  </span>
                </div>
                <div className='d-flex  gap-1 flex-wrap flex-column flex-lg-row'>
                  <Card className='cards-benefits' style={{flex: 1}}>
                    <Card.Body>
                      <div>
                        <span className='fs-6 fw-bold'>Monthly premium:</span>
                      </div>
                      <div>
                        <span className='fs-2 fw-bold'>
                          <small>
                            <sup>$</sup>
                          </small>
                          {Math.floor(Number(plan.premium_w_credit))}
                          <small>
                            <sup>.{Number(plan.premium_w_credit).toFixed(2).slice(-2)}</sup>
                          </small>
                        </span>
                      </div>
                      <p className='m-0 p-0 text-muted'>
                        Savings total:{' '}
                        <span className='text-success fw-bold'>
                          {Number(Number(plan.premium) - Number(plan.premium_w_credit)).toFixed(2)}
                        </span>
                      </p>
                      <p className='m-0 p-0 text-muted'>
                        Plan was: <span className='text-danger fw-bold'>{plan.premium}</span>
                      </p>
                    </Card.Body>
                  </Card>
                  <Card className='cards-benefits' style={{flex: 1}}>
                    <Card.Body>
                      <div>
                        <span className='fs-6 fw-bold'>Deductible</span>
                      </div>
                      <div>
                        <span className='fs-2 fw-bold'>
                          <small>
                            <sup>$</sup>
                          </small>
                          {Math.floor(Number(plan.deductibles?.[0]?.amount))}
                        </span>
                      </div>
                      <p className='m-0 p-0 text-muted'>
                        {plan.deductibles?.[0]?.family_cost || ''} total{' '}
                        {plan.deductibles?.[1]?.amount &&
                          `($${plan.deductibles[1].amount || 'N/R'} per person)`}
                      </p>
                      <p className='m-0 p-0 text-muted'> {plan.deductibles?.[0]?.type || 'N/R'}</p>
                    </Card.Body>
                  </Card>
                  <Card className='cards-benefits' style={{flex: 1}}>
                    <Card.Body>
                      <div>
                        <span className='fs-6 fw-bold'>Out-of-pocket max:</span>
                      </div>
                      <div>
                        <span className='fs-2 fw-bold'>
                          {plan.moops
                            ?.filter(
                              (moop) =>
                                moop.type ===
                                'Maximum Out of Pocket for Medical and Drug EHB Benefits (Total)'
                            )
                            ?.sort((a, b) => (b.family ? 1 : 0) - (a.family ? 1 : 0)) // Priorizar family: true
                            ?.find(() => true)?.amount || 'N/R'}
                        </span>
                      </div>

                      <p className='m-0 p-0 text-muted'>
                        {plan.moops
                          ?.filter(
                            (moop) =>
                              moop.type ===
                              'Maximum Out of Pocket for Medical and Drug EHB Benefits (Total)'
                          )
                          ?.sort((a, b) => (b.family ? 1 : 0) - (a.family ? 1 : 0)) // Priorizar family: true
                          ?.find(() => true)?.family
                          ? 'Family total'
                          : 'Individual total'}
                      </p>

                      <p className='m-0 p-0 text-muted'>
                        {plan.moops
                          ?.filter(
                            (moop) =>
                              moop.type ===
                              'Maximum Out of Pocket for Medical and Drug EHB Benefits (Total)'
                          )
                          ?.sort((a, b) => (b.family ? 1 : 0) - (a.family ? 1 : 0)) // Priorizar family: true
                          ?.find(() => true)
                          ?.type?.replace('Out of Pocket', '') || 'N/R'}
                      </p>
                    </Card.Body>
                  </Card>
                </div>
              </Card.Body>
              <Card.Footer>
                <Row>
                  <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                    <h5>Primary Doctor visits</h5>
                    <p>
                      {plan.benefits.find(
                        (p) => p.type === 'PRIMARY_CARE_VISIT_TO_TREAT_AN_INJURY_OR_ILLNESS'
                      )?.cost_sharings?.[0]?.display_string || 'N/R'}
                    </p>
                  </Col>
                  <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                    <h5>Specialist Visits</h5>

                    {(() => {
                      const inNetwork = plan.benefits
                        .find((p) => p.type === 'SPECIALIST_VISIT')
                        ?.cost_sharings?.find((cs) => cs.network_tier === 'In-Network')

                      const outNetwork = plan.benefits
                        .find((p) => p.type === 'SPECIALIST_VISIT')
                        ?.cost_sharings?.find((cs) => cs.network_tier === 'Out-of-Network')

                      if (inNetwork?.display_string === outNetwork?.display_string) {
                        return <div>{inNetwork?.display_string || 'N/R'}</div>
                      }
                      // Si uno de los valores es "Not Covered", mostrar solo el otro
                      if (inNetwork?.display_string === 'Not Covered') {
                        return <div>{outNetwork?.display_string || 'N/R'}</div>
                      }

                      if (outNetwork?.display_string === 'Not Covered') {
                        return <div>{inNetwork?.display_string || 'N/R'}</div>
                      }

                      return (
                        <>
                          {inNetwork ? (
                            <div>
                              <strong>In-Network:</strong> {inNetwork.display_string}
                            </div>
                          ) : (
                            <div>
                              <strong>In-Network:</strong> N/R
                            </div>
                          )}
                          {outNetwork ? (
                            <div>
                              <strong>Out-of-Network:</strong> {outNetwork.display_string}
                            </div>
                          ) : (
                            <div>
                              <strong>Out-of-Network:</strong> N/R
                            </div>
                          )}
                        </>
                      )
                    })()}
                  </Col>
                  <Col xs={12} sm={12} md={6} lg={4} xl={3}>
                    <h5>Urgent care</h5>

                    {(() => {
                      const inNetwork = plan.benefits
                        .find((p) => p.type === 'URGENT_CARE_CENTERS_OR_FACILITIES')
                        ?.cost_sharings?.find((cs) => cs.network_tier === 'In-Network')

                      const outNetwork = plan.benefits
                        .find((p) => p.type === 'URGENT_CARE_CENTERS_OR_FACILITIES')
                        ?.cost_sharings?.find((cs) => cs.network_tier === 'Out-of-Network')

                      if (inNetwork?.display_string === outNetwork?.display_string) {
                        return <div>{inNetwork?.display_string || 'N/R'}</div>
                      }
                      // Si uno de los valores es "Not Covered", mostrar solo el otro
                      if (inNetwork?.display_string === 'Not Covered') {
                        return <div>{outNetwork?.display_string || 'N/R'}</div>
                      }

                      if (outNetwork?.display_string === 'Not Covered') {
                        return <div>{inNetwork?.display_string || 'N/R'}</div>
                      }

                      return (
                        <>
                          {inNetwork ? (
                            <div>
                              <strong>In-Network:</strong> {inNetwork.display_string}
                            </div>
                          ) : (
                            <div>
                              <strong>In-Network:</strong> N/R
                            </div>
                          )}
                          {outNetwork ? (
                            <div>
                              <strong>Out-of-Network:</strong> {outNetwork.display_string}
                            </div>
                          ) : (
                            <div>
                              <strong>Out-of-Network:</strong> N/R
                            </div>
                          )}
                        </>
                      )
                    })()}

                    {/* <p>
                      {plan.benefits.find((p) => p.type === 'URGENT_CARE_CENTERS_OR_FACILITIES')
                        ?.cost_sharings?.[0]?.display_string || 'N/R'}
                    </p> */}
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                    <h5>Mental health</h5>

                    {(() => {
                      const inpatient = plan.benefits.find(
                        (p) => p.type === 'MENTAL_BEHAVIORAL_HEALTH_INPATIENT_SERVICES'
                      )?.cost_sharings?.[0]?.display_string

                      const outpatient = plan.benefits.find(
                        (p) => p.type === 'MENTAL_BEHAVIORAL_HEALTH_OUTPATIENT_SERVICES'
                      )?.cost_sharings?.[0]?.display_string

                      if (inpatient || outpatient) {
                        return (
                          <>
                            {inpatient && (
                              <div>
                                <strong>Inpatient:</strong> {inpatient}
                              </div>
                            )}
                            {outpatient && (
                              <div>
                                <strong>Outpatient:</strong> {outpatient}
                              </div>
                            )}
                          </>
                        )
                      } else {
                        return 'N/R'
                      }
                    })()}
                  </Col>
                  <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                    <h5>Emergencies</h5>

                    {(() => {
                      const inNetwork = plan.benefits
                        .find((p) => p.type === 'EMERGENCY_ROOM_SERVICES')
                        ?.cost_sharings?.find((cs) => cs.network_tier === 'In-Network')

                      const outNetwork = plan.benefits
                        .find((p) => p.type === 'EMERGENCY_ROOM_SERVICES')
                        ?.cost_sharings?.find((cs) => cs.network_tier === 'Out-of-Network')

                      if (inNetwork?.display_string === outNetwork?.display_string) {
                        return <div>{inNetwork?.display_string || 'N/R'}</div>
                      }

                      return (
                        <>
                          {inNetwork ? (
                            <div>
                              <strong>In-Network:</strong> {inNetwork.display_string}
                            </div>
                          ) : (
                            <div>
                              <strong>In-Network:</strong> N/R
                            </div>
                          )}
                          {outNetwork ? (
                            <div>
                              <strong>Out-of-Network:</strong> {outNetwork.display_string}
                            </div>
                          ) : (
                            <div>
                              <strong>Out-of-Network:</strong> N/R
                            </div>
                          )}
                        </>
                      )
                    })()}

                    {/* <p>
                      {plan.benefits.find((p) => p.type === 'EMERGENCY_ROOM_SERVICES')
                        ?.cost_sharings?.[0]?.display_string || 'N/R'}
                    </p> */}
                  </Col>
                  <Col xs={12} sm={12} md={6} lg={4} xl={3}>
                    <h5>Generic drugs</h5>
                    <p>
                      {plan.benefits.find((p) => p.type === 'GENERIC_DRUGS')?.cost_sharings?.[0]
                        ?.display_string || 'N/R'}
                    </p>
                  </Col>
                </Row>
              </Card.Footer>
            </Card>
          ))}
          {result.plans.length === 0 && (
            <Card>
              <Card.Header>
                <Card.Title>There are no more plans</Card.Title>
              </Card.Header>
              <Card.Body>
                <div className='d-flex align-items-center justify-content-center'>
                  <Lottie
                    animationData={endLottie}
                    autoPlay
                    style={{maxWidth: '50%', borderRadius: '60px', overflow: 'hidden'}}
                  />
                </div>
              </Card.Body>
            </Card>
          )}
        </div>
      </div>
      {infoPlan && isOpen && (
        <ModalInfoPlan
          isOpen={isOpen}
          onClose={onClose}
          onSave={onSelectPlan}
          planInput={infoPlan}
          queryData={queryData}
          planId={infoPlan.id}
        />
      )}
    </>
  )
}
